<ng-container *ngIf="vm$ | async as vm">
    <uni-label [required]="true">
        {{'ci.common.selectDay' | translate}}
    </uni-label>
    <app-form-single-select
        (valueChange)="frequencyWeekDayChange($event)"
        [value]="vm.value"
        [options]="vm.entities"
        [canClear]="false"
        [placeholder]="'ci.common.selectDay' | translate"
    ></app-form-single-select>
</ng-container>